import i18n from '../../i18n'

/**
 * Create a RegExp to Capture Frequency of some format in a Quartz Cron Member
 * @param {RegExp} pattern The pattern of member
 * @param {RegExp} additionalValidator Extra validator to capture members out of frequencies
 */
function memberFrequencyRegEx (pattern, additionalValidator = undefined) {
  const patternStr = pattern.source
  const additionalPattern = additionalValidator ? `|${additionalValidator.source}` : ''

  // Validator of all possible member patterns with specified pattern
  const allPatterns =
  `((${patternStr}|\\*)\\/(\\d+))|` + // Validator of member period
  `((${patternStr})-(${patternStr}))|` + // Validator of member range
  `((${patternStr}))` // Validator of simple member

  return new RegExp(
    '^(' +
    `(((${allPatterns}),)+(${allPatterns}))|` + // List of members definition
    `(${allPatterns})|` + // Some member definition
    '(\\*)' + // Every member definition
    `${additionalPattern}` + // Aditional capture of member
    ')$'
  )
}

const secondsRE = memberFrequencyRegEx(/[1-5]?[0-9]/)
const minutesRE = memberFrequencyRegEx(/[1-5]?[0-9]/)
const hoursRE = memberFrequencyRegEx(/[0-9]|1[0-9]|2[0-3]/)
const monthDayRE = memberFrequencyRegEx(/[1-9]|[1-2][0-9]|30|31/, /(([1-9]|[1-2][0-9]|30|31)W)|LW|L/)
const weekDayRE = memberFrequencyRegEx(/[1-7]|(MON|TUE|WED|THU|FRI|SAT|SUN)|([1-7]#[1-5])|((MON|TUE|WED|THU|FRI|SAT|SUN)#[1-5])/, /([1-7]L)|L/)
const monthRE = memberFrequencyRegEx(/[1-9]|1[0-2]|(JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)/)

/**
 * Validate a cron expression
 * @param {string} cron - The cron expression to be validated
 * */
export default function cronRules (cron) {
  if (!cron) return [i18n.t('warnings.validation.required')]
  const members = cron.trim().split(/\s+/)
  if (members.length > 6) return [i18n.t('warnings.validation.cron.extra_members')]
  if (members.length < 6) return [i18n.t('warnings.validation.cron.few_members')]

  const [seconds, minutes, hours, monthDay, month, weekDay] = members

  if (!secondsRE.test(seconds)) return [`${i18n.t('warnings.validation.cron.seconds')}: ${seconds}`]
  if (!minutesRE.test(minutes)) return [`${i18n.t('warnings.validation.cron.minutes')}: ${minutes}`]
  if (!hoursRE.test(hours)) return [`${i18n.t('warnings.validation.cron.hours')}: ${hours}`]

  if (monthDay !== '?' && weekDay !== '?') return [i18n.t('warnings.validation.cron.weekday_or_monthday')]
  if (monthDay === '?' && weekDay === '?') return [i18n.t('warnings.validation.cron.no_weekday_or_monthday')]

  const isMonthDay = monthDay !== '?'
  if (isMonthDay) {
    if (!monthDayRE.test(monthDay)) return [`${i18n.t('warnings.validation.cron.monthday')}: ${monthDay}`]
  } else {
    if (!weekDayRE.test(weekDay)) return [`${i18n.t('warnings.validation.cron.weekday')}: ${weekDay}`]
  }

  if (!monthRE.test(month)) return [`${i18n.t('warnings.validation.cron.month')}: ${month}`]

  return []
}
